import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Page, AlphaCard, SkeletonBodyText, Button, Pagination } from '@shopify/polaris';
// import { SearchMinor } from '@shopify/polaris-icons';
import { getOrderRange, getOrders } from '../../controller';
import { setOrders } from '../../store/slices/orderSlice';
import OrdersList from '../OrdersList';
import './style.css'

const loadingRow = <tr className='orderTableRows'>
  {
    (() => {
      const rows = []
      for (let i = 0; i < 7; i++) {
        rows.push(<td><SkeletonBodyText lines={1} /></td>)
      }
      return rows
    })()
  }
</tr>

const Dashboard = () => {
  const app = useSelector((state) => state.app)
  const orderReducer = useSelector((state) => state.order)
  const dispatch = useDispatch()

  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(0)
  const [totalOrders, setTotalOrders] = useState(0)
  const [totalPages, setTotalPages] = useState(0)

  const ordersList = () => {
    setLoading(true);
    (async () => {
      const response = await getOrders(app.store.shopId, page)
      setTotalOrders(response.totalOrders ?? 0)
      setTotalPages(Math.ceil(response.totalOrders / 50))
      dispatch(setOrders(response.success ? response.orders : []))
      setLoading(false)
    })()
  }


  useEffect(() => {
    if (Object.hasOwnProperty.call(app.store, 'shopId')) {
      ordersList()
    }
  }, [page])

  return (
    <Page fullWidth
      title="Orders"
      primaryAction={
        <Button primary onClick={ordersList}>
          Refresh Orders List
        </Button>
      }
    >
      <AlphaCard>
        <table className="orderTable">
          <thead className="orderTableHead">
            <th style={{ "width": "80px" }}>Order#</th>
            <th style={{ "width": "100px" }}>Tracking#</th>
            <th style={{ "width": "140px" }}>Date</th>
            <th>Customer</th>
            <th style={{ "width": "102px" }}>Total</th>
            <th style={{ "width": "300px" }}>Address</th>
            <th style={{ "width": "100px" }}>Status</th>
            <th style={{ "textAlign": "center" }}>Action</th>
          </thead>
          <tbody>
            {
              loading ? <>
                {loadingRow}
                {loadingRow
                }</> : (orderReducer.list.length ? <OrdersList loadingRow={loadingRow} /> : <tr className='emptyRow even'><td colSpan={8}>There are no orders click to <Button plain onClick={ordersList}>reload</Button> the list</td></tr>)
            }
          </tbody>
        </table>
        <div
          style={{
            "display": "flex",
            "justifyContent": "center"
          }}
        >
          <Pagination
            type="table"
            hasPrevious={page > 0}
            onPrevious={() => {
              setPage(page => page - 1)
            }}
            hasNext={page < (totalPages - 1)}
            onNext={() => {
              setPage(page => page + 1)
            }}
            label={getOrderRange(page + 1, 50, totalOrders)}
          />
        </div>
      </AlphaCard>
    </Page>
  )
}

export default Dashboard